var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbarContainer"},[_c('img',{attrs:{"src":require("../assets/logo.png")},on:{"click":_vm.home}}),_c('img',{staticClass:"menu",attrs:{"src":require("../assets/calendrier.png")},on:{"click":_vm.openDetail}})])
}
var staticRenderFns = []

export { render, staticRenderFns }